// extracted by mini-css-extract-plugin
export var container = "_3d-0";